export enum LoginModalTypeEnum {
  Login,
  Subscribe,
  ValidateDigitCode,
  ForgotPassword,
  ResetPassword,
  Close,
  SubscribeSimplified,
  SubscribeFinalized,
}
